// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N02C","importantInfo":"styles_importantInfo__20Tmp"};